import * as firebase from 'firebase';
import {firebaseConfig} from '../config';


class FirebaseApi {

  static initAuth() {
    firebase.initializeApp(firebaseConfig);
    return new Promise((resolve, reject) => {
      const unsub = firebase.auth().onAuthStateChanged(
        user => {
          unsub();
          resolve(user);
        },
        error => reject(error)
      );
    });
  }

  static createUserWithEmailAndPassword(user){
    return firebase.auth().createUserWithEmailAndPassword(user.email, user.password);
  }

  static signInWithEmailAndPassword(user) {
    return firebase.auth().signInWithEmailAndPassword(user.email, user.password);
  }

  static authSignOut(){
    return firebase.auth().signOut();
  }

  static databasePush(path, value) {
    return new Promise((resolve, reject) => {
      let succeed = false
      let ref = firebase
        .database()
        .ref(path)
        .push(value, (error) => {
          if (error) {
            reject(error);
          } else {
            succeed = true
          }
        });
      resolve(ref.getKey())
    });
  }

  static GetValueByKeyOnce(path, key) {
    return firebase
      .database()
      .ref(path)
      .orderByKey()
      .equalTo(key)
      .once('value');
  }

  static GetValues(path) {
    return firebase
      .database()
      .ref(path)
      .once('value')
  }

  static GetValuesWithDateFilter(path, filter_name,filter_value) {
    return firebase
      .database()
      .ref(path)
      .orderByChild(filter_name)
      .startAt(filter_value)
      .once('value')

  }

  static GetChildAddedByKeyOnce(path, key) {
    return firebase
      .database()
      .ref(path)
      .orderByKey()
      .equalTo(key)
      .once('child_added');
  }

  static databaseSet(path, value) {

    return firebase
      .database()
      .ref(path)
      .set(value);

  }

  static databaseUpdate(path, value) {

    return firebase
      .database()
      .ref(path)
      .update(value)
  }

  static RemoveChildByKey(path,key) {
    return firebase
      .database()
      .ref(path)
      .child(key)
      .remove()
  }

  static serverTimestamp() {
    return firebase.database.ServerValue.TIMESTAMP
  }
}

export default FirebaseApi;



// WEBPACK FOOTER //
// ./src/api/firebase.js